import React from "react"
import styled from "styled-components"
import { map, filter } from "lodash"

import { device } from "utils"

import BlogCard from "./PostCard"
import moment from "moment"
import { useMemo } from "react"

const MorePosts = ({ posts, extraPosts }) => {
  const filteredPosts = useMemo(() => {
    const range = moment().subtract(90, "days")
    const blogsInRange = filter(posts.edges, ({ node: { date } }) =>
      moment(date).isAfter(range)
    )

    const count = 3 - blogsInRange.length

    for (let index = 0; index < count; index++) {
      blogsInRange.push(extraPosts.edges[index])
    }

    return blogsInRange
  }, [posts, extraPosts])

  const renderMorePosts = () =>
    map(filteredPosts, ({ node }) => <BlogCard key={node.id} {...node} />)

  return (
    <StyledMorePosts>
      <ul className="MorePostsList">{renderMorePosts()}</ul>
    </StyledMorePosts>
  )
}

const StyledMorePosts = styled.div`
  margin-top: var(--sp-24);
  width: 100%;
  .MorePostsList {
    width: 100%;
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;
    grid-gap: var(--sp-32) var(--sp-8);

    @media ${device.laptop} {
      grid-gap: var(--sp-32) var(--sp-8);
      grid-template-columns: repeat(3, 1fr);
    }
  }
`

export default MorePosts
